import { Box, Flex, Heading } from "@chakra-ui/react";
import { FC, ReactNode } from "react";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";

interface BulletinDownloadTableProps {
  title: string;
  renderContent: () => JSX.Element | null;
  buttonElement?: ReactNode;
  spacing?: string;
  fontSize?: string;
}

const BulletinDownloadTable: FC<BulletinDownloadTableProps> = ({
  title = "",
  renderContent,
  buttonElement,
  spacing = 4,
  fontSize = "2xl",
}) => {
  return (
    <Flex direction="column" gap={spacing}>
      <Heading as="h3" fontSize={fontSize}>
        {title}
      </Heading>
      <Box>{buttonElement}</Box>
      <Box border={borderStyle} padding="3" borderRadius={borderRadius}>
        {renderContent()}
      </Box>
    </Flex>
  );
};

export default BulletinDownloadTable;
